import { apiGet, apiPost, apiDelete } from './client';

// ===== Types =====

export type PersonalApiTokenStatus = 'active' | 'expired' | 'revoked';

export interface PersonalApiToken {
  id: number;
  name: string;
  createdAt: string;
  expiresAt: string;
  lastUsedAt: string | null;
  status: PersonalApiTokenStatus;
}

export type PersonalApiTokenExpiryDays = 30 | 90 | 180 | 365;

export interface CreateTokenInput {
  name: string;
  expiryDays: PersonalApiTokenExpiryDays;
}

// Shape of the create response — mirrors the backend's `patCreateResponse`
// schema (backend/src/api/schemas/personalApiToken.ts), which enumerates
// ONLY these four fields; fast-json-stringify strips everything else, so
// `createdAt` / `lastUsedAt` / `status` are NOT present here (review WR-04).
export interface CreateTokenResult {
  id: number;
  name: string;
  expiresAt: string;
  token: string; // plaintext — only ever present on the create response (show-once, PAT-01 / D-09)
}

// ===== API calls =====

export async function listPersonalApiTokens(): Promise<PersonalApiToken[]> {
  const res = await apiGet<{ data: PersonalApiToken[] }>('/personal-api-tokens');
  return res.data;
}

export async function createPersonalApiToken(
  input: CreateTokenInput
): Promise<CreateTokenResult> {
  const res = await apiPost<{ data: CreateTokenResult }>('/personal-api-tokens', input);
  return res.data;
}

export async function revokePersonalApiToken(id: number): Promise<{ success: boolean }> {
  const res = await apiDelete<{ data: { success: boolean } }>(`/personal-api-tokens/${id}`);
  return res.data;
}
